import { Box, IconButton } from '@mui/material'
import { Dismiss16Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

/** Shows the excerpt that will be included with the user's refinement request. */
export default function ComposerRefinementPreview({ text, onDismiss }) {
  return (
    <Box className={styles.refinementPreviewCard} role="status" aria-label="Selected text for refinement">
      <Box className={styles.refinementPreviewMain}>
        <Box className={styles.refinementPreviewText} title={text}>
          {text}
        </Box>
        <Box className={styles.refinementPreviewHeader}>
          <Box component="span" className={styles.refinementPreviewLabel}>
            Pasted
          </Box>
        </Box>
      </Box>
      <Tooltip text="Remove selected text" placement="top">
        <IconButton type="button" size="small" className={styles.refinementPreviewDismiss} onClick={onDismiss} aria-label="Remove selected text">
          <Dismiss16Regular className={styles.refinementPreviewDismissIcon} aria-hidden />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
